import {
  PluginTangoRequest,
  PluginTangoResponse,
} from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runTangoRequest = (
  constructPost: ConstructPost,
  data: PluginTangoRequest,
): Promise<NonPaginatedResponse<PluginTangoResponse> | undefined> =>
  constructPost<NonPaginatedResponse<PluginTangoResponse>>(
    `${PLUGIN_BASE_PATH}/tango-request`,
    { data },
    { preventDefaultErrorToast: true },
  );
